export const domains = [
  '@docomo.ne.jp',
  '@ezweb.ne.jp',
  '@i.softbank.jp',
  '@softbank.ne.jp',
  '@gmail.com',
  '@icloud.com',
  '@au.com',
  '@d.vodafone.ne.jp',
  '@h.vodafone.ne.jp',
  '@t.vodafone.ne.jp',
  '@c.vodafone.ne.jp',
  '@k.vodafone.ne.jp',
  '@r.vodafone.ne.jp',
  '@n.vodafone.ne.jp',
  '@s.vodafone.ne.jp',
  '@q.vodafone.ne.jp',
  '@pdx.ne.jp',
  '@wcm.ne.jp',
  '@di.pdx.ne.jp',
  '@wm.pdx.ne.jp',
  '@dj.pdx.ne.jp',
  '@willcom.com',
  '@dk.pdx.ne.jp',
  '@y-mobile.ne.jp',
  '@emnet.ne.jp',
  '@ymobile.ne.jp',
  '@emobile.ne.jp',
  '@ymobile1.ne.jp',
  '@emobile-s.ne.jp',
  '@disney.ne.jp',
  'それ以外',
]
